// extracted by mini-css-extract-plugin
export default {"box":"VRGatUI1c0yXmImftZaW"};